import React, { useEffect, useState } from 'react'
import "./RenderPopover.scss"
import Popover from '@mui/material/Popover';
import Button from 'react-bootstrap/esm/Button';

function RenderPopoverComment({ handleCloseComment, index, anchorElComment, openComment, rowsData, handleReason, reason, readOnly }: any) {


  // const [remarks, setRemarks] = useState<any>();
  // //console.log(rowsData, "rows Data inside child popover comment");
  // useEffect(() => {
  //   handleReason(remarks, index)
  //   // console.log("handle reason remark : ",remarks)
  // }, [remarks])

  return (
    <div className='popper-wrapper-insurance'>
      <Popover
        open={openComment}
        anchorEl={anchorElComment}
        onClose={handleCloseComment}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ width: "100%" }}
      >
        <div className='popper-wrapper-comment'>
          <div className='blue-common-heading'>Comment</div>
          <div className='wrapper-inputs-col'>
            <div className="title-name">Remarks</div>
            <textarea
              className="form-control-width"
              style={{ outline: 'none' }}
              name="remarks"
              rows={5}
              cols={15}
              disabled={readOnly}
              value={rowsData[index].remarks}
              onChange={(e: any) => {
                handleReason(e.target.value, index)
              }}
            />{" "}
          </div>
          <div style={{ height: "30px" }}></div>
          {/* <Button className='common-button'>Save</Button> */}
        </div>
      </Popover>
    </div>
  )
}

export default RenderPopoverComment

